import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=3e98d039&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=3e98d039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e98d039",
  null
  
)

export default component.exports